import React, { useMemo, useState } from 'react';
import { MagnifyingGlass, Plus } from '@phosphor-icons/react';
import { Button, Input } from 'app/components';
import Question from '../question';

const SearchForm = (props) => {
  const {
    questions,
    onAddQuestion,
    onAddCustomQuestion,
  } = props;

  const [searchText, setSearchText] = useState('');

  const getSearchResults = useMemo(() => {
    if (searchText) {
      return questions?.filter(
        (item) => item.label.toLowerCase().includes(searchText.toLowerCase())
          || item.type.toLowerCase().includes(searchText.toLowerCase()),
      );
    }

    return questions;
  }, [searchText, questions]);

  return (
    <div className="search-form">
      <Input
        iconLeft={<MagnifyingGlass size={24}
          color="#101010" />}
        width="100%"
        placeholder="Search or Add a question"
        value={searchText}
        onChange={(e) => setSearchText(e?.target?.value)}
      />
      <div className="questions-container flex flex-col gap-3 mt-4 pr-4">
        {getSearchResults?.length ? (
          getSearchResults?.map((item) => (
            <Question
              {...item}
              add={true}
              icon={<Plus />}
              className="cursor-pointer"
              onClick={() => onAddQuestion(item)}
            />
          )))
          : (
            <Button
              type="tertiary-text"
              iconLeft={<Plus />}
              onClick={() => onAddCustomQuestion(searchText)}
            >
              Ask a custom question
            </Button>
          )}
      </div>
    </div>
  );
};

export default SearchForm;
